/* src/app/app.component.scss */
div.modalwait {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10000;
}
.modalwait > .background {
  position: absolute;
  top: 50%;
  height: 200px;
  margin-top: -100px;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
  box-shadow: #000000 0px 3px 10px 0;
}
.cs-loader {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.cs-loader > span {
  top: calc(50% - 3.5em);
  position: absolute;
  width: 100%;
  color: #444;
  padding: 0 0;
  text-align: center;
  font-size: 1.5em;
}
.cs-loader .loadinglogo {
  top: 50%;
  position: absolute;
  width: 100%;
  background-image: url("./media/reflex_loading-3FQAE3KT.png");
  height: 100px;
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: 10em;
}
.cs-loader-inner {
  transform: translateY(-50%);
  top: 48%;
  position: absolute;
  width: 100%;
  color: #444;
  padding: 0 0;
  text-align: center;
}
.cs-loader-inner label {
  font-size: 20px;
  opacity: 0;
  display: inline-block;
}
.cs-loader > .progress {
  top: 48%;
  position: absolute;
  width: 100%;
  padding: 0;
  text-align: center;
  font-size: 0.8em;
  height: 1em;
}
@keyframes lol {
  0% {
    opacity: 0;
    transform: translateX(-300px);
  }
  33% {
    opacity: 1;
    transform: translateX(0px);
  }
  66% {
    opacity: 1;
    transform: translateX(0px);
  }
  100% {
    opacity: 0;
    transform: translateX(300px);
  }
}
@-webkit-keyframes lol {
  0% {
    opacity: 0;
    -webkit-transform: translateX(-300px);
  }
  33% {
    opacity: 1;
    -webkit-transform: translateX(0px);
  }
  66% {
    opacity: 1;
    -webkit-transform: translateX(0px);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateX(300px);
  }
}
.cs-loader-inner label:nth-child(6) {
  -webkit-animation: lol 3s infinite ease-in-out;
  animation: lol 3s infinite ease-in-out;
}
.cs-loader-inner label:nth-child(5) {
  -webkit-animation: lol 3s 100ms infinite ease-in-out;
  animation: lol 3s 100ms infinite ease-in-out;
}
.cs-loader-inner label:nth-child(4) {
  -webkit-animation: lol 3s 200ms infinite ease-in-out;
  animation: lol 3s 200ms infinite ease-in-out;
}
.cs-loader-inner label:nth-child(3) {
  -webkit-animation: lol 3s 300ms infinite ease-in-out;
  animation: lol 3s 300ms infinite ease-in-out;
}
.cs-loader-inner label:nth-child(2) {
  -webkit-animation: lol 3s 400ms infinite ease-in-out;
  animation: lol 3s 400ms infinite ease-in-out;
}
.cs-loader-inner label:nth-child(1) {
  -webkit-animation: lol 3s 500ms infinite ease-in-out;
  animation: lol 3s 500ms infinite ease-in-out;
}
/*# sourceMappingURL=app.component-BMVH3T3H.css.map */
